import API from "serviceshift-ui/api-client";

export default {
  clearAppointment({ commit }) {
    commit("replace", {
      state: "appointment",
      data: null
    });
  },
  createAppointment(_, { link, payload }) {
    return API.makeRequest(link, {
      method: "POST",
      data: payload
    });
  },
  fetchAppointment({ commit }, id) {
    return API.makeRequest(`/v2/appointments/${id}`).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  cancelAppointment({ commit }, { id, reason }) {
    return API.makeRequest(`/v2/appointments/${id}/cancel`, {
      method: "PUT",
      data: {
        reason
      }
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointment({ commit }, { link, data }) {
    const { href, method } = link;
    return API.makeRequest(href, {
      method,
      data
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointmentStatus({ commit }, { link, params }) {
    const { href, method } = link;
    return API.makeRequest(href, {
      method,
      data: params
    }).then((res) => {
      commit("replace", {
        state: "appointment",
        data: res.data
      });
    });
  },
  updateAppointmentTimes({ commit }, { id, ...data }) {
    return API.makeRequest(`/v2/appointments/${id}/actual_times`, {
      method: "PUT",
      data: data
    }).then((res) => {
      commit("replace", {
        state: "job",
        data: res.data
      });
    });
  },
  // ignoreError: the close-out gate's 409 has no `message`, so the interceptor's
  // generic flash and RUM report would both be wrong here. The caller inspects the
  // rejection itself for every transition through this action, so nothing may be
  // swallowed silently.
  async updateAppointmentStatusAndTimes(_, { link, params }) {
    const { href, method } = link;
    const res = await API.makeRequest(href, {
      method,
      data: params,
      headers: { ignoreError: true }
    });
    return res.data;
  }
};
